var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_20340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_20340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17.25V5.25C2.25 4.8375 2.39675 4.4845 2.69025 4.191C2.98425 3.897 3.3375 3.75 3.75 3.75H11.25C11.6625 3.75 12.0157 3.897 12.3097 4.191C12.6033 4.4845 12.75 4.8375 12.75 5.25V17.25L7.5 15L2.25 17.25ZM3.75 14.9625L7.5 13.35L11.25 14.9625V5.25H3.75V14.9625ZM14.25 15V2.25H4.5V0.75H14.25C14.6625 0.75 15.0157 0.89675 15.3097 1.19025C15.6033 1.48425 15.75 1.8375 15.75 2.25V15H14.25Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmak);
export default __webpack_public_path__ + "static/media/bookmak.30528c1ef6025ff3caa098230ae5a35c.svg";
export { ForwardRef as ReactComponent };